const getVisuallyHiddenStyles = () => {
  return {
    position: 'absolute',
    width: 1,
    height: 1,
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  };
};

export { getVisuallyHiddenStyles };
//# sourceMappingURL=visuallyHiddenStyles.js.map
